import React from 'react'
import ListDataVrf from './ListDataVrf'
import { useEffect,useState } from 'react'
import {useDispatch } from 'react-redux'
import axios from "../../../../../Global/axios";
import { setAppError } from '../../../../../store/userSlice'



export default function GRVRF() {
  const dispatch = useDispatch()
  const token = localStorage.getItem("token")
  const [updateVrfData,setUpdateVrfData] = useState(false)
  const [loading,setLoading] = useState(false)
  const [Data, SetData] = useState([])
  const [VRFData, setVRFData] = useState([]);
  const [FilterValue, setFilterValue] = useState("All");
  
  const ListDatatitles = [
    "Sno",
    "VRF no",
    "Project",
    "Visa provider name",
    "Recruitment Agency",
    "GR Status",
    "Remark",
    "Requested quantity",
    "GR Requested quantity",
    "Actual Position",
    "Country",
    "Visa Profession",
    "Available Quantity",
    "Action",
  ];
   
  

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/dashboard/gr-visa-vrf", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          SetData(response.data.data);
          if (FilterValue == "All") {
             setVRFData(response.data.data)
          } else {
            const fileterdStatus = response?.data?.data?.filter((item) => {
              return item?.gr_status == FilterValue;
            });
            setVRFData(fileterdStatus);
           }
          setLoading(false);
        }
      } catch (e) {
        dispatch(setAppError({ msg: e.message }));
        setLoading(false);
      }
    };
    fetchData()
    
  }, [updateVrfData]);

  useEffect(() => {
    if (FilterValue == "All") {
      setVRFData(Data);
    } else {
      const fileterdStatus = Data.filter((item) => {
        return item.gr_status == FilterValue;
      });
      setVRFData(fileterdStatus);
    }
  },[FilterValue])

    
  
  
  return (
    <div>
      <ListDataVrf
        setUpdateVrfData={setUpdateVrfData}
        vrfData={VRFData}
        Loading={loading}
        titles={ListDatatitles}
        setVRFData={setVRFData}
        Data={Data}
        FilterValue={FilterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
}

